import React from "react";

import FooterItems from "../components/FooterItems";
import logo from "../../assets/image/logo.svg";

import { FaFacebook } from "react-icons/fa";
import { FaTwitterSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";

import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <img src={logo} alt="logo" />

      <FooterItems
        title="Quick Links"
        items={["About Us", "Blog", "Contact", "FAQ"]}
      />

      <FooterItems
        title="Legal Stuff"
        items={[
          "Disclaimer",
          "Financing",
          "Privacy Policy",
          "Terms of Service",
        ]}
      />

      <FooterItems
      className ="social-links"
        title="Social Links"
        items={[
          <FaFacebook className="social-icon"/>,
          <FaTwitterSquare className="social-icon" />,
          <FaLinkedin className="social-icon" />,
          <FaPinterest className="social-icon" />,
        ]}
      />
    </div>
  );
};

export default Footer;
